import { useForm } from "react-hook-form";
import { Box, chakra, Flex, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { EsgLabel, FormInput, NumericFormInput } from "../../../../../../../components/Forms";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { translateSubElementString } from "../../../../../../../utils";
import { mapData } from "./utils";
import { Answer } from "../../../../../../SupplierPhysicalRiskQuestionnaire/components/PhysicalRiskAssessmentForm/components";

const categoryThreeAttributes = ["calculationMethods", "carbonEmission", "howVerifyData", "reasonExclusion"];

function CategoryThree({ tabKey, currentElement, callMethod, isPreview }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire.scopeThree"
  });
  const formDefaultValues = mapData(categoryThreeAttributes, currentElement);

  const [included, setIncluded] = useState("yes");

  useEffect(() => {
    if (currentElement) {
      setIncluded(currentElement.included === true ? "yes" : "no");
    }
  }, [currentElement]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: formDefaultValues
  });

  const onSubmit = (data) => {
    if (!isPreview) {
      const apiData = mapData(categoryThreeAttributes, data);
      apiData.included = included === "yes";
      apiData.categoryKey = tabKey;

      if (isDirty || apiData.included !== currentElement?.included) {
        callMethod(apiData);
      } else {
        callMethod(null);
      }
      reset({});
    }
  };

  return (
    <chakra.form
      id={`navForm${tabKey}`}
      onSubmit={handleSubmit(onSubmit)}
      flexGrow="1"
      overflowY="auto"
      overflowX="visible"
      paddingBlockEnd="4"
      paddingInline="2"
      marginInline="-2"
      height="calc(100% - var(--chakra-space-16))"
    >
      <Flex direction="column" marginBlockStart={5} gap={5}>
        <Flex direction="column">
          {isPreview ?
            <Box>
              <EsgLabel text={t("includeQuestion", { activity: t("categories.categoryThree.activity") })} />
              <Answer
                answerText={included ?
                  t(`buttons.${included}`) : ""}
              />
            </Box> :
            <>
              <Text fontSize="sm" opacity="0.75">
                {t("includeQuestion", { activity: t("categories.categoryThree.activity") })}
              </Text>
              <RadioGroup value={included} mb={5} style={{ position: "relative" }}>
                <Stack spacing={5} direction="row">
                  <Radio
                    colorScheme="customScheme"
                    value="yes"
                    onChange={e => {
                      setIncluded(e?.target.value);
                    }}
                  >
                    {t("buttons.yes")}
                  </Radio>
                  <Radio
                    colorScheme="customScheme"
                    value="no"
                    onChange={e => {
                      setIncluded(e?.target.value);
                    }}
                  >
                    {t("buttons.no")}
                  </Radio>
                </Stack>
              </RadioGroup>
            </>
          }
        </Flex>

        <Flex direction="column" gap={5}>
          {included === "yes" ?
            isPreview ?
              <>
                <Box>
                  <EsgLabel marginBlockStart={5}
                            text={translateSubElementString("supplierQuestionnaire.scopeThree.emissions")} />
                  <Answer answerText={formDefaultValues.carbonEmission?.toString()} />
                </Box>
                <Box>
                  <EsgLabel marginBlockStart={5}
                            text={t("calculationMethods")} />
                  <Answer answerText={formDefaultValues.calculationMethods} />
                </Box>
                <Box>
                  <EsgLabel marginBlockStart={5}
                            text={t("howVerifyData")} />
                  <Answer answerText={formDefaultValues.howVerifyData} />
                </Box>
              </> :
              <>
                <NumericFormInput
                  label={translateSubElementString("supplierQuestionnaire.scopeThree.emissions")}
                  errors={errors}
                  {...register("carbonEmission")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("calculationMethods")}
                  errors={errors}
                  {...register("calculationMethods")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("howVerifyData")}
                  errors={errors}
                  {...register("howVerifyData")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
              </> :
            isPreview ?
              <Box>
                <EsgLabel marginBlockStart={5}
                          text={t("reasonForExclusion")} />
                <Answer answerText={formDefaultValues.reasonExclusion} />
              </Box> :
              <FormInput
                label={t("reasonForExclusion")}
                errors={errors}
                {...register("reasonExclusion")}
                maxInlineSize={{ base: "full", lg: "lg" }}
              />
          }
        </Flex>
      </Flex>
    </chakra.form>
  );
}

export default CategoryThree;